import React from 'react'
import { Card } from "react-bootstrap";
import styles from './BusinessObjectives.module.scss';
import BusinessObjectiveCard from '../BusinessObjectiveCard/BusinessObjectiveCard';

export default function BusinessObjectives() {
    const objective = [
        {
            objective: 'Optimize company supply chain',
            quarter: 'Q1 FY24',
            category: 'Procurement',
            progressCount: 70,
            track: 'On track'
        },
        {
            objective: 'Reduce overall risk in FY24',
            quarter: 'Q1 FY24',
            category: 'Risk',
            progressCount: 50,
            track: 'On track'
        },
        {
            objective: 'Increase customer aquisition',
            quarter: 'Q2 FY24',
            category: 'Sales',
            progressCount: 0,
            track: 'Not started'
        },
        {
            objective: 'Streamline risk processes',
            quarter: 'Q3 FY23',
            category: 'Risk',
            progressCount: 30,
            track: 'Delayed'
        }
    ]
    return (
      <Card className={styles.card}>
        <div className={styles.cardBody}>
          <div className="row mb-3">
            <div className="col">
              <span>Business objectives</span>
              <span className={styles.inProgress}>10 in progress</span>
            </div>
            <div className="col-md-3">
              <span>View all</span>
            </div>
          </div>
          {objective.map((obj, i) => (
            <div className="row" key={i}>
              <BusinessObjectiveCard
                progressCount={obj.progressCount}
                category={obj.category}
                objective={obj.objective}
                quarter={obj.quarter}
                track={obj.track}
              ></BusinessObjectiveCard>
            </div>
          ))}
        </div>
      </Card>
    );
}
